import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
  CHECKPOINT_NAME_NOT_UNIQUE: {
    defaultMessage: 'There is already a Checkpoint with this name',
    id: 'CHECKPOINT_NAME_NOT_UNIQUE'
  },
  QR_CODE_NOT_UNIQUE: {
    defaultMessage: 'There is already a Checkpoint with this QR code',
    id: 'QR_CODE_NOT_UNIQUE'
  }
});
